// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.disaster-recovery-module__eap-container___RKPLG {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.disaster-recovery-module__eap-container___RKPLG p {
  margin-bottom: 10px;
}

.disaster-recovery-module__eap-container___RKPLG button img {
  filter: invert(1);
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./client/app/pages/entry/disaster-recovery/disaster-recovery.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,mBAAA;AAMF;;AAHA;EACE,mBAAA;AAMF;;AAHA;EACE,iBAAA;EACA,gBAAA;AAMF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '~wa-storybook/styles/utils';\n\n.eap-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.eap-container p {\n  margin-bottom: 10px;\n}\n\n.eap-container button img {\n  filter: invert(1);\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eap-container": `disaster-recovery-module__eap-container___RKPLG`
};
export default ___CSS_LOADER_EXPORT___;
